export default __webpack_public_path__ + "static/media/logo_shopify.a8f5865c.svg";